import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../HandleAPICalls/actions";
import { useParams, useNavigate } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import FranchiseeUpdateComponent from "./component";

const UpdateFranchiseeDetailsContainer = (props) => {
  const { franchiseeId, id, cohortId } = useParams();
  const navigate = useNavigate();
  const [updateFranchisee, setUpdateFranchisee] = useState({});
  const [loading, setLoading] = useState(false);
  const [formDataFranchisee, setFormDataFranchisee] = useState({});
  const [warehouseList, setWarehouseList] = useState([]);

  useEffect(() => {
    setLoading(true);
    props.getDataFromAPI(
      `/dashboard/api/v2/admin/franchisee/${franchiseeId}`,
      "GET",
      undefined,
      (response) => {
        console.log("Franchisee API Response:", response);
        
        // Transform the API response to match your form structure
        const formDataWithNumbers = {
          name: response.name || "",
          description: response.description || "",
          cohortId: response.cohortId ? parseInt(response.cohortId) : "",
          ownerId: response.ownerId ? Number(response.ownerId) : 
                  (response.owner?.id ? Number(response.owner.id) : ""),
          warehouseId: response.warehouse?.id || response.warehouseId || "",
           cohortTypeId: response.cohortTypeId ? Number(response.cohortTypeId) : "",
        type: response.type || "",
        };
        
        setUpdateFranchisee(response);
        setFormDataFranchisee(formDataWithNumbers);
        setLoading(false);
      },
      (err) => {
        console.log("error---", err);
        toastr.error("Failed", "Unable to fetch franchisee details");
        setLoading(false);
      }
    );
  }, [franchiseeId, id, cohortId]);

  useEffect(() => {
    getWarehouseList();
  }, []);

  const getWarehouseList = () => {
    props.getDataFromAPI(
      "/partner/api/v2/warehouse/list",
      "GET",
      undefined,
      (response) => {
        console.log("warehouseData:", response);
        // Map response data into proper format
        const normalizedList = response.map((wh) => ({
          id: wh.warehouseId,
          name: wh.warehouseName,
          city: wh.warehouseCity,
        }));
        setWarehouseList(normalizedList);
      },
      (err) => {
        console.log("error:", err);
        toastr.error("Failed", "Unable to fetch warehouse listing");
      }
    );
  };

  const handleUpdateFranchisee = (event) => {
    const { name, value } = event.target;
    
    // Handle numeric values
    let processedValue = value;
    if (name === "ownerId" || name === "warehouseId" || name === "cohortTypeId") {
      processedValue = value === "" ? "" : Number(value);
    }
    
    setFormDataFranchisee((prevData) => ({
      ...prevData,
      [name]: processedValue,
    }));
  };

  const handleApicallToUpdate = () => {
    handleChangeUpdateFranchisee();
  };

  const handleChangeUpdateFranchisee = async () => {
    // Validate required fields
    if (!formDataFranchisee.name) {
      toastr.error("Validation Error", "Name is required");
      return;
    }

    // Prepare the data for the PATCH request matching the exact payload format
    const formDataToSend = {
      name: formDataFranchisee.name,
      description: formDataFranchisee.description || "",
      ownerId: Number(formDataFranchisee.ownerId),
      warehouseId: formDataFranchisee.warehouseId ? Number(formDataFranchisee.warehouseId) : null,
      cohortId: parseInt(formDataFranchisee.cohortId),
      cohortTypeId: formDataFranchisee.cohortTypeId ? Number(formDataFranchisee.cohortTypeId) : null
    };

    console.log("Data being sent to API:", formDataToSend);

    try {
      const response = await props.getDataFromAPI(
        `/dashboard/api/v2/admin/franchisee/${franchiseeId}`,
        "PATCH",
        formDataToSend
      );

      console.log("Update response franchisee-------", response);
      toastr.success("Success", "Franchisee updated successfully");
      navigate(-1);
    } catch (error) {
      console.error("Error updating franchisee:", error);
      toastr.error("Failed", "Unable to update franchisee");
    }
  };

  return (
    <FranchiseeUpdateComponent
      loading={loading}
      formDataFranchisee={formDataFranchisee}
      handleUpdateFranchisee={handleUpdateFranchisee}
      handleApicallToUpdate={handleApicallToUpdate}
      warehouseList={warehouseList}
    />
  );
};

export default connect(null, {
  getDataFromAPI,
})(UpdateFranchiseeDetailsContainer);